// Countdown Timer - Shopify Theme
// Requiere ser llamado desde una sección o snippet

class CountdownTimer {
  constructor(containerId, options = {}) {
    this.container = document.getElementById(containerId);
    if (!this.container) return;

    // Configuración por defecto
    this.options = {
      mode: options.mode || 'evergreen', // 'evergreen' o 'date'
      targetDate: options.targetDate || null, // Formato: 'YYYY-MM-DD'
      resetHour: parseInt(options.resetHour) || 0, // Hora en que se reinicia (modo evergreen)
      resetMinute: parseInt(options.resetMinute) || 0,
      duration: parseInt(options.duration) || 24, // Duración en horas (modo evergreen)
      showAnimation: options.showAnimation !== false,
      storageKey: 'countdown_timer_end_' + (options.storageKey || 'default')
    };

    this.init();
  }

  init() {
    this.setupEndTime();
    this.startCountdown();
    this.handleCloseButton();
  }

  setupEndTime() {
    const now = new Date();
    let endTime = null;

    if (this.options.mode === 'date' && this.options.targetDate) {
      // Modo: fecha específica
      endTime = new Date(this.options.targetDate + 'T23:59:59').getTime();
    } else {
      // Modo: evergreen (diario)
      const storedEndTime = localStorage.getItem(this.options.storageKey);
      
      if (storedEndTime) {
        endTime = parseInt(storedEndTime);
        // Verificar si el tiempo almacenado ya pasó
        if (endTime < now.getTime()) {
          endTime = this.calculateNextEndTime(now);
          localStorage.setItem(this.options.storageKey, endTime);
        }
      } else {
        endTime = this.calculateNextEndTime(now);
        localStorage.setItem(this.options.storageKey, endTime);
      }
    }

    this.endTime = endTime;
  }

  calculateNextEndTime(now) {
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(this.options.resetHour, this.options.resetMinute, 0, 0);
    return tomorrow.getTime();
  }

  startCountdown() {
    this.updateDisplay();
    this.intervalId = setInterval(() => this.updateDisplay(), 1000);
  }

  updateDisplay() {
    const now = new Date().getTime();
    const timeLeft = this.endTime - now;

    if (timeLeft <= 0) {
      this.handleExpired();
      return;
    }

    const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
    const seconds = Math.floor((timeLeft / 1000) % 60);

    this.displayTime(hours, minutes, seconds);
  }

  displayTime(hours, minutes, seconds) {
    const hoursEl = this.container.querySelector('[data-countdown-hours]');
    const minutesEl = this.container.querySelector('[data-countdown-minutes]');
    const secondsEl = this.container.querySelector('[data-countdown-seconds]');

    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
    if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');

    // Agregar clase de animación si quedan menos de 60 segundos
    if (hours === 0 && minutes === 0) {
      this.container.classList.add('countdown-timer--urgency');
    } else {
      this.container.classList.remove('countdown-timer--urgency');
    }
  }

  handleExpired() {
    clearInterval(this.intervalId);
    
    if (this.options.mode === 'evergreen') {
      // Reiniciar para el próximo día
      localStorage.removeItem(this.options.storageKey);
      this.setupEndTime();
      this.startCountdown();
    } else {
      // Modo fecha específica: ocultar o mostrar mensaje
      this.container.classList.add('countdown-timer--expired');
      const hoursEl = this.container.querySelector('[data-countdown-hours]');
      const minutesEl = this.container.querySelector('[data-countdown-minutes]');
      const secondsEl = this.container.querySelector('[data-countdown-seconds]');
      
      if (hoursEl) hoursEl.textContent = '00';
      if (minutesEl) minutesEl.textContent = '00';
      if (secondsEl) secondsEl.textContent = '00';
    }
  }

  handleCloseButton() {
    const closeBtn = this.container.querySelector('[data-countdown-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.container.style.display = 'none';
        localStorage.setItem(this.options.storageKey + '_closed', 'true');
        
        // Reaparece después de 24 horas
        setTimeout(() => {
          localStorage.removeItem(this.options.storageKey + '_closed');
          this.container.style.display = 'block';
        }, 24 * 60 * 60 * 1000);
      });

      // Verificar si fue cerrado recientemente
      if (localStorage.getItem(this.options.storageKey + '_closed')) {
        this.container.style.display = 'none';
      }
    }
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  // Buscar todos los contadores en la página
  document.querySelectorAll('[data-countdown-timer]').forEach(element => {
    const containerId = element.id;
    const mode = element.getAttribute('data-countdown-mode') || 'evergreen';
    const targetDate = element.getAttribute('data-countdown-date');
    const resetHour = element.getAttribute('data-countdown-reset-hour');
    const resetMinute = element.getAttribute('data-countdown-reset-minute');
    const duration = element.getAttribute('data-countdown-duration');
    const storageKey = element.getAttribute('data-countdown-storage-key');

    new CountdownTimer(containerId, {
      mode: mode,
      targetDate: targetDate,
      resetHour: resetHour,
      resetMinute: resetMinute,
      duration: duration,
      storageKey: storageKey
    });
  });
});
